import { Component } from "@angular/core";
import { Router } from "@angular/router";


import { HttpService } from "./http.service";


@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent {
  title = "裕能科技用戶資料雲";

  constructor(public httpService: HttpService, private router: Router) { }

  async OnLogout() {
    await this.httpService.Logout();
  }
  public onCheckPremission() {
    return (this.httpService.userinfo.usertype >= 0x20);
  }
}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/app.component.ts